import {TOGGLE_OPTION_HIDDEN, SORT_OPTIONS, SAVE_NOTE, DELETE_NOTE, BULK_TOGGLE_OPTIONS_HIDDEN, TOGGLE_STAR, UPDATE_REVIEW_STAGE} from '../actions/userEdits'
import { SAVE_TR_FOR_RESPONSE } from '../actions/translation';

const userEdits = (state = {}, action) => {
  switch(action.type){

    case TOGGLE_OPTION_HIDDEN:
      var userEdits = state[action.section] || {};
      var hiddenOptIDs = userEdits["hiddenOptIDs"] || [];
      if (hiddenOptIDs.indexOf(action.option.id) === -1) {
        // hiding
        return {
          ...state,
          [action.section]: {
            ...userEdits,
            hiddenOptIDs: [
              ...hiddenOptIDs,
              action.option.id
            ]
          }
        }
      } else {
        // unhiding
        return {
          ...state,
          [action.section]: {
            ...userEdits,
            hiddenOptIDs: [
              ...hiddenOptIDs.filter((id) => id !== action.option.id)
            ]
          }
        }
      }

    case TOGGLE_STAR:
      var userEdits = state[action.section] || {};
      var starred = userEdits["starred"] || [];
      if (starred.indexOf(action.option.id) === -1) {
        // starring
        return {
          ...state,
          [action.section]: {
            ...userEdits,
            starred: [
              ...starred,
              action.option.id
            ]
          }
        }
      } else {
        // un-starring
        return {
          ...state,
          [action.section]: {
            ...userEdits,
            starred: [
              ...starred.filter((id) => id !== action.option.id)
            ]
          }
        }
      }


    case BULK_TOGGLE_OPTIONS_HIDDEN:
      var userEdits = state[action.section] || {};
      var hiddenOptIDs = [...(userEdits["hiddenOptIDs"] || [])];
      for (var id of action.ids) {
        if (hiddenOptIDs.indexOf(id) === -1) {
          hiddenOptIDs.push(id);
        }
      }
      return {
        ...state,
        [action.section]: {
          ...userEdits,
          hiddenOptIDs: hiddenOptIDs
        }
      }
    case SORT_OPTIONS: //optionIDs, response
      var sectionObj = state[action.section] || {};
      return {
        ...state,
        [action.section]:{
          ...sectionObj,
          userSortOrder: action.optionIDs
        }
      }

    case SAVE_NOTE: //optionID, notes
      var notesList = state["userNotes"] || {};

      return{
        ...state,
        userNotes: {
          ...notesList,
          [action.optionID]: action.notes
        }
      }

    case DELETE_NOTE: //optionID
      var notesList = state["userNotes"] || {};
      delete notesList[action.optionID];
      return{
        ...state,
        userNotes:{
          ...notesList
        }
      }

    case UPDATE_REVIEW_STAGE:
      var sectionObj = state[action.section] || {};
      var oldStage = sectionObj.reviewStage || 0; //if reviewStage is undefined, set as 0
      return {
        ...state,
        [action.section]: {
          ...sectionObj,
          reviewStage: action.stage > oldStage ? action.stage : oldStage
        }
      }

    case SAVE_TR_FOR_RESPONSE:
      return{
        ...state,
        trIDForResponse:action.trID
      }

    default:
      return state;
  }
}

export default userEdits;
